import { Injectable } from "@angular/core";
import { BaseHandler } from "@app/core/shared/data/network/base-handler";
import { map, Observable } from "rxjs";
import {
  HandlerBuilder,
  HttpMethod,
} from "@app/core/shared/data/network/base-handler.parameters";
import { ApiUrls } from "@app/core/shared/data/network/api-urls";
import { TokenAuthorization } from "@app/core/shared/data/network/token-authorization";
import { BookingMapper } from "@app/core/booking/data/network/booking.mapper";
import { Booking } from "@app/core/booking/domain/model/booking";
import { MATCH_REQUEST_KEY } from "@app/core/booking/data/network/match-request-key";

@Injectable({ providedIn: "root" })
export class UnapplyCouponWS {
  constructor(private baseHandler: BaseHandler) {}

  execute(
    bookingId: string,
    couponCode: string,
    token: string
  ): Observable<Booking> {
    const parameters = new HandlerBuilder()
      .setUrl(ApiUrls.UNAPPLY_COUPON_ENDPOINT(bookingId))
      .setMethod(HttpMethod.post)
      .setAuthorization(new TokenAuthorization(token))
      .setBody({
        reference: couponCode,
      })
      .build();
    return this.baseHandler
      .execute(parameters)
      .pipe(
        map((response) => {
          return BookingMapper.deserialize(response);
        })
      );
  }
}
